export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";